import { ItemFilter, ItemGroup, ItemGroupFormValue, ItemGroupSpu } from './type';
import { cloneDeep, filter, forEach, map } from 'lodash-es';

export const isItemFilterValid = (itemFilter: ItemFilter): boolean => {
  if (itemFilter.target === 'PLATFORM_SKU') {
    return itemFilter.specifiedItem.length > 0;
  } else {
    return (
      filter(itemFilter.itemFilterPair, (pair) => {
        return !!pair.keyword;
      }).length > 0
    );
  }
};

// 验证itemFilter, blacklist 有效值，并返回有效值
export const validateItemFilter = (itemFilters: ItemFilter[]): ItemFilter[] => {
  return filter(itemFilters, isItemFilterValid);
};

export const convertItemstoItemGroupSpus = (items: ItemSelectV2.Item[]): ItemGroupSpu[] => {
  return map(items, (item) => {
    return {
      itemInternalId: item.internalItemId,
      sku: map(item.skuInfo, (sku) => {
        return {
          skuId: sku.skuId,
          sellerSku: sku.sellerSku,
        };
      }),
    };
  });
};

export const removeUselessFilter = <
  T extends { itemFilter: ItemFilter[]; blacklist: ItemFilter[] },
>(
  values: T,
): T => {
  const copy = cloneDeep(values);
  copy.itemFilter = validateItemFilter(copy.itemFilter);
  forEach(copy.itemFilter, (each) => {
    if (each.target === 'PLATFORM_SKU') {
      each.itemFilterPair = [];
    } else {
      each.specifiedItem = [];
    }
  });
  copy.blacklist = validateItemFilter(copy.blacklist);
  forEach(copy.blacklist, (each) => {
    if (each.target === 'PLATFORM_SKU') {
      each.itemFilterPair = [];
    } else {
      each.specifiedItem = [];
    }
  });
  return copy;
};
export const defaultItemGroupFormValue: ItemGroupFormValue = {
  name: '',
  departmentId: [],
  itemFilter: [
    {
      target: 'SELLER_SKU',
      itemFilterPair: [
        {
          keyword: '',
          condition: 'START_WITH',
        },
      ],
      specifiedItem: [],
    },
  ],
  blacklist: [
    {
      target: 'PLATFORM_SKU',
      itemFilterPair: [
        {
          keyword: '',
          condition: 'START_WITH',
        },
      ],
      specifiedItem: [],
    },
  ],
};
export const patchDefaultItemGroupFormValue = (value: ItemGroup): ItemGroupFormValue => {
  const copy = cloneDeep(value);
  forEach(copy.itemFilter, (each) => {
    if (each.target === 'PLATFORM_SKU') {
      each.itemFilterPair = defaultItemGroupFormValue.itemFilter[0].itemFilterPair;
    } else {
      each.specifiedItem = [];
    }
  });
  if (copy.blacklist.length === 0) {
    copy.blacklist = defaultItemGroupFormValue.blacklist;
  } else {
    forEach(copy.blacklist, (each) => {
      if (each.target === 'PLATFORM_SKU') {
        each.itemFilterPair = defaultItemGroupFormValue.blacklist[0].itemFilterPair;
      } else {
        each.specifiedItem = [];
      }
    });
  }
  return copy;
};
